import React from 'react';

import { CustomModal } from '@shared/ui';

import { ModalBodyTasksMonth } from './ModalBodyTasksMonth/ModalBodyTasksMonth';
import { useModalTasksMonth } from './useModalTasksMonth';

interface ModalTasksMonthProps {
    classes?: string;
}

export const ModalTasksMonth = ({ classes }: ModalTasksMonthProps) => {
    const { modalMode, onHideModal } = useModalTasksMonth();
    return (
        // todo не перевел потому что пока не используется и будет переделываться
        <CustomModal
            classes={classes}
            isOpen={modalMode === 'tasksMonth'}
            onHideModal={onHideModal}
        >
            <CustomModal.Header>Задачи на 3 апреля 2024</CustomModal.Header>
            <CustomModal.Body>
                <ModalBodyTasksMonth />
            </CustomModal.Body>
        </CustomModal>
    );
};
